import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrencyPipe } from '@frontend/sports/common/core/feature/money';
import { PlainLinkComponent } from '@frontend/vanilla/core';
import { AccaBoostBaseModule } from 'packages/sports/web/app/src/acca-boost-base/acca-boost-base.module';
import { DirectivesModule } from 'packages/sports/web/app/src/directives/directives.module';

import { AccaBoostCarouselMaxBoostItemContentComponent } from './components/acca-boost-carousel-max-boost-item-content/acca-boost-carousel-max-boost-item-content.component';
import { AccaBoostCarouselComponent } from './components/acca-boost-carousel/acca-boost-carousel.component';
import { AccaBoostCarouselItemDirective } from './components/digital/acca-boost-carousel-item/acca-boost-carousel-item.directive';
import { AccaBoostRerendererDirective } from './components/digital/acca-boost-rerenderer.directive';
import { AccaBoostContextService } from './services/acca-boost-context.service';
import { AccaBoostNotificationHandlerService } from './services/acca-boost-notification-handler.service';
import { AccaBoostNotificationService } from './services/acca-boost-notification.service';
import { AccaBoostSummaryService } from './services/acca-boost-summary.service';

@NgModule({
    imports: [CommonModule, AccaBoostBaseModule, DirectivesModule, PlainLinkComponent, CurrencyPipe],
    declarations: [
        AccaBoostCarouselItemDirective,
        AccaBoostCarouselComponent,
        AccaBoostCarouselMaxBoostItemContentComponent,
        AccaBoostRerendererDirective,
    ],
    exports: [
        AccaBoostCarouselItemDirective,
        AccaBoostCarouselComponent,
        AccaBoostCarouselMaxBoostItemContentComponent,
        AccaBoostRerendererDirective,
    ],
    providers: [AccaBoostContextService, AccaBoostSummaryService, AccaBoostNotificationService, AccaBoostNotificationHandlerService],
})
export class SharedAccaBoostModule {}
